<template>
    <v-btn class="my-8 mx-0 pa-0 text-size-md text-secondary-dark" variant="plain" :to="{ name: routeNames.home }">
        <template #prepend>
            <svg-icon :icon="back" alt="back" />
        </template>

        {{ t('startPage.backToHome') }}
    </v-btn>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import back from '@/assets/back.svg';
import { routeNames } from '@/router';

const { t } = useI18n();
</script>
